module.exports = __webpack_public_path__ + "img/bf-science.e6d23c9f.png";